module.exports = __webpack_public_path__ + "static/media/instagram_logo.e710a000.svg";